import { useEffect, useState } from 'react';
import useCountriesList from '../../hooks/useCountriesList';
import SearchDropdown from './searchDropdown';
interface Props {
  onSelect: any;
  selectedProvince: any;
  provincesList: any[];
  isDisabled?: boolean;
}
const ProvincesSelect = ({
  onSelect,
  selectedProvince,
  provincesList,
  isDisabled,
}: Props) => {
  const [provincesListFormatted, setProvincesListFormatted] = useState<any>([]);

  useEffect(() => {
    if (provincesList && provincesList.length > 0) {
      const formattedProvinceList: any = provincesList.map((item: any) => ({
        label: item?.name,
        value: item.code,
      }));
      setProvincesListFormatted(formattedProvinceList);
    }
  }, [provincesList]);
  return (
    <SearchDropdown
      id={'province-dropdown'}
      isDisabled={isDisabled}
      placeholder={'Select a province'}
      selectedValue={selectedProvince}
      options={provincesListFormatted && provincesListFormatted}
      onSelect={(item) => {
        onSelect(item.value);
      }}
    />
  );
};

export default ProvincesSelect;
